import * as React from 'react';

const TagSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="tag_svg__eds-icon--tag_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="tag_svg__eds-icon--tag_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6 3l9 9-8.6 8.6-9-9V3h8.6zm.4-1H2v10l10 10 10-10L12 2z"
        />
        <path
            id="tag_svg__eds-icon--tag_circle"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
        />
    </svg>
);

TagSvg.displayName = 'TagSvg';
export default TagSvg;
